export default __webpack_public_path__ + "static/media/linda.78ddbd14.jpg";